import React from 'react';

function Header() {
    return (
        <div className="title">
            <div className="nav">
                <h1>Gallerina</h1>
            </div>
            <h2>Your Pictures</h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
        </div>
    )
}

export default Header;
